import { useState } from "react"
import styled from "styled-components"

import { UITypes } from "types"
import { ReactComponent as IconPencil } from "assets/svg/icon-pencil.svg"

import { EditColumnsModal } from "modals/EditColumnsModal"

const Button = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 8px;

  svg {
    position: relative;
    flex-shrink: 0;
  }
`

interface EditColumnsButtonProps {
  tableName: string
  tableHeaderCells: UITypes.TableHeaderCell[]
}

const EditColumnsButton = ({ tableName, tableHeaderCells }: EditColumnsButtonProps) => {
  const [showEditColumnsModal, setShowEditColumnsModal] = useState(false)

  const onEditColumnsClick = () => {
    setShowEditColumnsModal(true)
  }

  return (
    <>
      <Button onClick={onEditColumnsClick}>
        <span> Edit columns</span>
        <IconPencil />
      </Button>
      {showEditColumnsModal && (
        <EditColumnsModal
          tableName={tableName}
          tableHeaderCells={tableHeaderCells}
          onCancel={() => setShowEditColumnsModal(false)}
        />
      )}
    </>
  )
}

export default EditColumnsButton
